// Item #34 - aviso nao bloqueante de mensalidade em aberto antes do bloqueio.
// Exibe um toast temporario no mesmo padrao dos demais avisos do sistema.
// Reaparece no proximo bootstrap porque situacaoFinanceira nao fica persistida
// em localStorage.
// So exibe quando a cobranca ja esta vencida (diasEmAberto >= 1) - pendencia
// ainda dentro do prazo nao gera aviso nenhum.
import { useContext, useEffect, useRef } from "react";
import { GlobalContext } from "../../Utils/GlobalContext";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";

function formatarVencimento(valor) {
  if (!valor) return null;
  const iso = String(valor).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso.split("-").reverse().join("/") : null;
}

function MensalidadePendenteAviso() {
  const { globalData } = useContext(GlobalContext);
  const situacaoFinanceira = globalData?.situacaoFinanceira;
  const { toast } = useFeedback();
  const jaExibidoNestaSessao = useRef(false);

  useEffect(() => {
    const sit = situacaoFinanceira;
    const diasEmAberto = Number(sit?.diasEmAberto) || 0;
    if (!sit?.temPendencia || sit.bloqueado || diasEmAberto < 1) return;
    if (jaExibidoNestaSessao.current) return;
    jaExibidoNestaSessao.current = true;

    const venc = formatarVencimento(sit.cobrancaMaisAntiga?.data_vencimento);
    const mensagem = venc
      ? `Ainda n\u00e3o identificamos o pagamento da sua mensalidade, vencida em ${venc}. Por favor, regularize o quanto antes para evitar o bloqueio do sistema.`
      : `Ainda n\u00e3o identificamos o pagamento da sua mensalidade, vencida h\u00e1 ${diasEmAberto} dia(s). Por favor, regularize o quanto antes para evitar o bloqueio do sistema.`;

    toast.warning(mensagem);
  }, [situacaoFinanceira, toast]);

  return null;
}

export default MensalidadePendenteAviso;
